import { MOST_ACTIVE_LIST_REQ, MOST_ACTIVE_LIST_SUCCESS, MOST_ACTIVE_LIST_ERROR } from './most-active.type'
import ApiRest from '@/api/api-rest'

const state = {
  mostActiveRequestStatus: ''
}

const getters = {
  mostActiveRequestStatus: state => state.mostActiveRequestStatus
}

const mutations = {
  [MOST_ACTIVE_LIST_REQ]: state => {
    state.mostActiveRequestStatus = 'loading'
  },
  [MOST_ACTIVE_LIST_SUCCESS]: state => {
    state.mostActiveRequestStatus = 'saved'
  },
  [MOST_ACTIVE_LIST_ERROR]: state => {
    state.mostActiveRequestStatus = 'error'
  }
}

const actions = {
  [MOST_ACTIVE_LIST_REQ] (context, queryType) {
    let apiEndpoint = '/bi/mostactive'
    if (!_.isEmpty(queryType.eventType)) {
      apiEndpoint = `${apiEndpoint}/${queryType.eventType}`
    }
    if (!_.isEmpty(queryType.osType)) {
      apiEndpoint = `${apiEndpoint}/${queryType.osType}`
    }
    if (!_.isEmpty(queryType.agentId)) {
      apiEndpoint = `${apiEndpoint}/${queryType.agentId}`
    }
    return new Promise((resolve, reject) => {
      context.commit(MOST_ACTIVE_LIST_REQ)
      ApiRest()
        .get(apiEndpoint)
        .then(({ data }) => {
          context.commit(MOST_ACTIVE_LIST_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(MOST_ACTIVE_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/statistics/most-active.module.js